class Loyal extends DrupalBehavior {

    onContent(context) {
        // getElementById('loyal-search')
        once("loyalPageChangeListener", 'html', context).forEach((el) => {
            document.getElementById('loyal-search').addEventListener('loyal:pagechange', (event) => {
                $('nav.breadcrumb').addClass('loader-with-blur');
                this.updateCanonical(event.detail.path);
                this.handleLoyalPageChange(event.detail.path);
            });
        });
    }

    handleLoyalPageChange(path) {
        // Two page changes in quick succession race each other, and whichever
        // response lands last wins regardless of which route the visitor is now
        // on. That was survivable while only the title, description and
        // breadcrumb were at stake; it is not once a robots directive is in
        // play, because a late location response would re-add noindex to a
        // provider page. Record the path asked for last and drop anything that
        // comes back for a different one.
        this.latestPath = path;
        $.ajax({
            url: "/loyal-search/landing-page/dynamic-page-components",
            data: {
                url: path
            },
            dataType: "json",
            method: "GET",
            success: (response) => {
                if (!response || path !== this.latestPath) {
                    return;
                }
                this.updatePageComponents(response);
            },
            error: function (xhr, status, error) {
                console.error("AJAX error:", status, error);
            }
        });
    }

    /**
     * Points the canonical link at the path Loyal has soft-navigated to.
     *
     * The canonical is rendered server side, so without this it keeps pointing at
     * whichever URL the page was first loaded with. The query string is dropped so
     * that a filtered search canonicalizes to the listing itself, which is what a
     * hard load of the same URL emits.
     */
    updateCanonical(path) {
        if (!path) {
            return;
        }
        let canonicalTag = document.querySelector('link[rel="canonical"]');
        if (!canonicalTag) {
            canonicalTag = document.createElement('link');
            canonicalTag.setAttribute('rel', 'canonical');
            document.head.appendChild(canonicalTag);
        }
        const url = new URL(path, window.location.href);
        canonicalTag.setAttribute('href', url.origin + url.pathname);
    }

    /**
     * Applies the robots directive of the route Loyal has soft-navigated to.
     *
     * Only the location and appointment routes carry one, so unlike the title
     * and description this tag is usually absent, and an empty value has to
     * remove it rather than blank it. Without that, a hop from a noindexed
     * location page to a provider would leave the provider advertising the
     * location's noindex, and the reverse would leave a location page with no
     * noindex at all.
     *
     * Googlebot loads each URL directly rather than clicking through the
     * widget, so the server-rendered tag is what actually governs indexing.
     * This keeps what the document says true of the URL in the address bar,
     * which is what anyone inspecting the page in a browser will check.
     */
    updateRobots(content) {
        let robotsTag = document.querySelector('meta[name="robots"]');
        if (!content) {
            if (robotsTag) {
                robotsTag.remove();
            }
            return;
        }
        if (!robotsTag) {
            robotsTag = document.createElement('meta');
            robotsTag.setAttribute('name', 'robots');
            document.head.appendChild(robotsTag);
        }
        robotsTag.setAttribute('content', content);
    }

    updatePageComponents(data) {
        const newTitle = data.meta_title;
        const newMetaDescription = data.meta_description;
        const newBreadcrumb = data.breadcrumb;
        document.title = newTitle;
        this.updateRobots(data.meta_robots);
        let metaDescriptionTag = document.querySelector('meta[name="description"]');
        if (!metaDescriptionTag) {
            metaDescriptionTag = document.createElement('meta');
            metaDescriptionTag.setAttribute('name', 'description');
            document.head.appendChild(metaDescriptionTag);
        }
        metaDescriptionTag.setAttribute("content", newMetaDescription);
        $('nav.breadcrumb').replaceWith(newBreadcrumb);
    }
}

  DrupalBehavior.register('summit_theme', 'loyal', Loyal);
